import { NgModule } from '@angular/core';
import { ClickOutsideDirective } from './clickoutside.directive';

@NgModule({
  imports: [ClickOutsideDirective],
  exports: [ClickOutsideDirective],
})
export class ClickOutsideModule {}
